import { HttpClient } from "../../../commonApis/httpClient";
import * as ApiEvents from './apiEvents'
import _ from "lodash";

export const mockResponseNL = (mrn, shipmentId, statusCode) => {
    const data = {
        eventMessage: {
          mrn,
          "functionalReferenceID":shipmentId,
          statusCode
        },
        eventTime: Date.now(),
        eventType: ApiEvents.GET_MOCK_RESPONSE,
    }
    return HttpClient.custom({
        data
    })
  }